var Cookies = require("../../node_modules/js-cookie");
// var URI = require("../../node_modules/urijs");

function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}

function sendMail(event) {
    var $this = $(this);
    var isValid = true;
    var captchaCode = grecaptcha.getResponse();
    var csrf = $("#csrf").val();
    var contact = $("#contact").val();
    var company = $("#company").val();
    var phone = $("#phone").val();
    var to = $("#to").val();
    var subject = $("#subject").val();
    var message = $("#msg_content").val();
    var focus = undefined;
    if (subject === "") {
        $("#subjectValidation").show().text("Es wurde kein Betreff angegeben").delay(6000).fadeOut();
        isValid = false;
        if (!focus) focus = $("#subject");
    }
    if (contact === "") {
        $("#contactValidation").show().text("Es wurde kein Ansprechpartner eingetragen").delay(6000).fadeOut();
        isValid = false;
        if (!focus) focus = $("#contact");
    }
    if (to === "" || isValidEmailAddress(to) === false) {
        $("#emailValidation").show().text("Die E-mail Adresse ist nicht valide").delay(6000).fadeOut();
        isValid = false;
        if (!focus) focus = $("#to");
    }
    if (captchaCode.length === 0) {
        $("#captchaValidation").show().text("Der Captcha Code ist nicht aktiviert").delay(6000).fadeOut();
        if (!focus) isValid = false;
    }

    if (isValid === true) {
        $this.button('loading');
        var mailData = {
            "to": to,
            "subject": subject,
            "message": message,
            "phone": phone,
            "contact": contact,
            "company": company,
            "g-recaptcha-response": captchaCode,
            "_csrf": csrf
        };
        $.ajax({
            type: 'POST',
            data: JSON.stringify(mailData),
            contentType: 'application/json',
            url: 'send',
            success: function (data) {
                clearForm();
                $this.button('reset');
                grecaptcha.reset();
            },
            error: function (data) {
                console.log(data.status + ": " + data.message);
                $("#message").show().text(data.message).delay(5000).hide(0);
                $this.button('reset');
                grecaptcha.reset();
            }
        });
        if (google_trackConversion) {
            console.log("send conversion");
            google_trackConversion();
        }
    } else if (focus) {
        focus.focus();
    }
}



function clearForm() {

    $("#to").val("");
    $("#subject").val("");
    $("#msg_content").val("");
    $("#phone").val("");
    $("#contact").val("");
    $("#company").val("");
    $("#captchaInput").val("");
    grecaptcha.reset();
}

$(document).ready(function () {
    $("#send_email").click(sendMail);
    $("#reset").click(clearForm);

    $("#mailchimp_form").submit(function (e) {
        e.preventDefault(e);
        subscribe();
        return false;
    });
    $("#mailchimp_submit").click(function () {
        $("#mailchimp_form").submit();
    });

    // $(".carousel").swipe({
    //     //Generic swipe handler for all directions
    //     swipeLeft: function (event, direction, distance, duration, fingerCount) {
    //         $(this).carousel('next');
    //     },
    //     swipeRight: function () {
    //         $(this).carousel('prev');
    //     },
    //     threshold: 25,
    //     excludedElements: "button, input, select, textarea, .noSwipe"
    // });
    // $(window).scroll(function() {
    //     var minimizedNavbarHeight = 50;
    //     if ($(document).scrollTop() > minimizedNavbarHeight) {
    //         $('nav').addClass('shrink');
    //     } else {
    //         $('nav').removeClass('shrink');
    //     }
    // });


    // Add smooth scrolling to all links
    $("[ais-smooth-scroll]").on('click', function (event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "" && this.pathname === window.location.pathname) {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').stop().animate({
                scrollTop: $(hash).offset().top
            }, 1000, 'swing', function () {

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });

    // if(ga && window.performance){
    //      ga('send', 'timing', 'Document ready', 'load', Math.round(performance.now()));
    // }
});

function delte_cookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


function set_locale(locale) {
    Cookies.set("locale", locale, { path: "/" });
    Cookies.set("changeLang", locale, { path: "/" });
    window.location.reload();
}

// BEGIN: subscribe form 

/// Mailchimp object
// {
// 	"email_address": "",
// 	"email_type": "",
// 	"status": "",
// 	"merge_fields": {},
// 	"interests": {},
// 	"language": "",
// 	"vip": "",
// 	"location": {
// 		"latitude": "",
// 		"longitude": ""
// 	},
// 	"marketing_permissions": "",
// 	"ip_signup": "",
// 	"timestamp_signup": "",
// 	"ip_opt": "",
// 	"timestamp_opt": "",
// 	"tags": ""
// }

function subscribe(event) {
    var $this = $(this);
    var focus = undefined;

    var reqPayload = {
        "_csrf": $("#csrf").val(),
        "g-recaptcha-response": grecaptcha.getResponse(),
        "member": {
            "email_address": $("#mailchimp_email").val(),
            "email_type": "html",
            "status": "pending",
            "merge_fields": {
                "FNAME": $("#mailchimp_name").val(),
                "LNAME": $("#mailchimp_surname").val(),
                "MESSAGE": $("#mailchimp_message").val(),
            },
            "interests": {
                "b429a7f270": document.getElementById("mailchimp_checkTrail").checked,
                "5dc1625cfd": document.getElementById("mailchimp_checkLicense").checked,
                "c7ab4ca121": document.getElementById("mailchimp_checkVersionUpdates").checked,
            },
            "language": $("#mailchimp_language").val(),
            // "vip": "",
            // "location": {
            //     "latitude": "",
            //     "longitude": ""
            // },
            "marketing_permissions": [
                {
                    "marketing_permission_id": "9ce6924e8d",
                    "text": "Email",
                    "enabled": true
                },
                {
                    "marketing_permission_id": "dc82c7b327",
                    "text": "Direct Mail",
                    "enabled": true
                },
                {
                    "marketing_permission_id": "cc15d9ca8d",
                    "text": "Customized Online Advertising",
                    "enabled": true
                }
            ],
            // "ip_signup": "",
            // "timestamp_signup": "",
            // "ip_opt": "",
            // "timestamp_opt": "",
            // "tags": ""
        }
    };

    if (isValidEmailAddress(reqPayload.member.email_address) === false) {
        $("#mailchimp_emailValidation").show().text("Die E-mail Adresse ist nicht valide.").delay(6000).fadeOut();
        focus = $("#mailchimp_email");
    }

    if (document.getElementById("mailchimp_checkDataprotection").checked === false) {
        $("#mailchimp_checkDataprotectionValidation").show().text("Stimmen Sie der Datenschutzbestimmung zu.").delay(6000).fadeOut();
        $('[for="mailchimp_checkDataprotection"]').addClass('border-red');
        focus = $("#mailchimp_checkDataprotection");
    }

    if (!reqPayload["g-recaptcha-response"]) {
        $("#captchaValidation").show().text("Der Captcha Code ist nicht aktiviert").delay(6000).fadeOut();
        if (typeof focus === 'undefined') focus = $("#captchaValidation");
    }

    if (focus) {
        focus.focus();
        return false;
    }

    $.ajax({
        type: 'POST',
        data: JSON.stringify(reqPayload),
        contentType: 'application/json',
        url: '/subscribe',
        beforeSend: () => {
            $("#mailchimp_submit").button("loading");
        },
        complete: () => {
            $("#mailchimp_submit").button("reset");
        },
        success: function (data) {
            $("#modalMailChimpForm").modal('hide');
            $('#modalMailChimpSuccess').modal('show');
        },
        error: function (data) {
            $("#modalMailChimpForm").modal('hide');
            $('#modalMailChimpError').modal('show');
        }
    });

    console.log(reqPayload);

}

$('#modalMailChimpForm').on('hidden.bs.modal', function (e) {
    $('#modalMailChimpForm').find('[type="text"]').val("");
    document.getElementById("mailchimp_checkTrail").checked = true;
    document.getElementById("mailchimp_checkLicense").checked = true;
    document.getElementById("mailchimp_checkVersionUpdates").checked = true;
    document.getElementById("mailchimp_checkDataprotection").checked = false;
    $("#captchaInput").val("");
    grecaptcha.reset();
});

// END: subscribe form

window.setLocal = set_locale;
// window.deleteCookie = delete_cookie;

$(document).ready(function () {
    var element = document.getElementById("copyrightYear");
    if (element) {
        element.innerHTML = (new Date()).getFullYear();
    }
})
